import { AsyncStorage } from '@pletly/common';
import { PostsFilter } from './type';

const POSTS_FILTER_STORAGE_KEY = 'feed-posts-filter';

async function getFilters(userId: number | string) {
	const filtersString = await AsyncStorage.getString(`${userId}_${POSTS_FILTER_STORAGE_KEY}`);

	if (!filtersString) {
		return;
	}

	return JSON.parse(filtersString, (key, value) => {
		if (key === 'startDate' || key === 'endDate') {
			return new Date(value);
		}

		return value as unknown;
	}) as PostsFilter;
}

async function setFilters(filters: PostsFilter, userId: number | string) {
	const filtersString = JSON.stringify(filters);

	return AsyncStorage.setStorageItem(`${userId}_${POSTS_FILTER_STORAGE_KEY}`, filtersString);
}

async function resetFilters(userId: number | string) {
	return AsyncStorage.removeItem(`${userId}_${POSTS_FILTER_STORAGE_KEY}`);
}

export { getFilters, setFilters, resetFilters };
